<div class="container">
    <div class="header">
        <app-button
            class="new-button"
            text="system-settings.fcu.button.add-fcu"
            [iconButton]="true"
            [noneMarginIcon]="true"
            iconSize="20px"
            icon="plus"
            [disable]="!canEditSettings || fcuUnitList?.length >= FCU_UNIT_MAX"
            (onClick)="openNewFcuSetting()"
            customFontSize="14px"
            customFontFamily="NotoSans-SemiBold"></app-button>
        <span class="description">
            {{
                (fcuUnitList?.length >= FCU_UNIT_MAX
                    ? 'system-settings.fcu.limit-reached'
                    : 'system-settings.fcu.description'
                ) | translate: { num: FCU_UNIT_MAX - fcuUnitList?.length || 0 }
            }}
        </span>
    </div>
    <div class="table" *ngIf="fcuUnitList.length">
        <div class="row table-header">
            <div class="cell table-header">
                {{ 'system-settings.fcu.table.header.fcu' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.fcu.sub-title.location' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.fcu.sub-title.fu' | translate }}
            </div>
            <div></div>
        </div>
        <div class="row" *ngFor="let fcuUnit of fcuUnitList">
            <div class="cell fcu-number">
                {{ fcuUnit.index }}
            </div>
            <div class="cell">
                <div class="location-wrapper">
                    <mat-icon
                        class="location-icon"
                        [class.not-input]="!fcuUnit?.location"
                        svgIcon="location"></mat-icon>
                    <span class="location-text" [class.not-input]="!fcuUnit?.location">{{
                        fcuUnit.location
                            ? fcuUnit.location
                            : ('system-settings.fcu.label.location.not-input' | translate)
                    }}</span>
                </div>
            </div>
            <div class="cell">
                <div class="screen-display-wrapper" [class.not-input]="!fcuUnit?.fuNum">
                    {{
                        'system-settings.fcu.data.fu-unit'
                            | translate
                                : {
                                      num: fcuUnit?.fuNum ? fcuUnit?.fuNum : 0,
                                  }
                    }}
                </div>
            </div>
            <div class="cell" style="justify-content: center;">
                <span
                    class="url"
                    data-cy="ops-settings-system-setting-fcu-view-fcu-button"
                    (click)="goViewFcuSetting(fcuUnit.id)"
                    >{{ 'system-settings.fcu.data.view-fcu' | translate }}</span
                >
            </div>
            <div class="cell options more-url" [class.selected]="isOpenOption && selectedFcuUnit?.id === fcuUnit.id">
                <mat-icon
                    class="more-icon"
                    data-cy="ops-settings-system-setting-fcu-kebab-icon"
                    svgIcon="more-options"
                    (click)="openMoreOption(fcuUnit); $event.stopImmediatePropagation()"></mat-icon>
                <div class="options-dialog" [class.show]="isOpenOption && selectedFcuUnit?.id === fcuUnit.id">
                    <div class="options-item" [class.disabled]="!canEditSettings" (click)="editFcuUnit(fcuUnit.id)">
                        {{ 'dlg.edit' | translate }}
                    </div>
                    <div
                        class="options-item"
                        [class.disabled]="!canEditSettings || fcuUnitList?.length >= FCU_UNIT_MAX"
                        (click)="duplicateFcuUnit(fcuUnit.id)">
                        {{ 'system-settings.fcu.more-option.duplicate' | translate }}
                    </div>
                    <div
                        class="options-item"
                        [class.disabled]="!canEditSettings || fcuUnitList?.length <= 1"
                        (click)="deleteFcuUnit(fcuUnit.id)">
                        {{ 'system-settings.fcu.more-option.delete' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirmation-window
    #deleteDialog
    [subLabel]="'system-settings.fcu.delete.sub.message'"
    [mainLabel]="deleteDialogMainLabel"
    [discardLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"
    [allButtonsLeft]="true"
    [inverseColors]="true"></app-confirmation-window>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
